import { useEffect } from "react"

import { useLocation } from "react-router-dom"
import { scrollToTop } from "utils/scroll"

export const useScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem("classListScrollPosition")
    const isReturningFromStudent = pathname.includes("/class/") && savedScrollPosition !== null
    
    if (isReturningFromStudent) {
      return
    }
    
    scrollToTop("auto")
  }, [pathname])
}
